import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Widget } from "@uploadcare/react-widget";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import Image from "next/image";
import { format } from "date-fns";
import { v4 as uuid } from "uuid";
import { isEmpty, includes } from "lodash";

import { KTGet, KTPost } from "@/kyna/lib/db";
import { KNThemeError } from "@/kyna/ui/toaster/KNTheme";
import { ClientDonationsSchema } from "@/kyna/lib/validations/DonationsSchema";
import { HONORIFICS } from "@/kyna/lib/StandardReferences";

import HeaderNav from "@/kyna/includes/HeaderNav";
import SelectInputForm from "@/kyna/forms/SelectInputForm";
import InputFormV2 from "@/kyna/forms/InputFormV2";
import InputForm from "@/kyna/forms/InputForm";
import Spinner from "@/kyna/ui/preloader/Spinner";
import Footer from "../../includes/Footer";
import KNModal from "@/kyna/ui/modal/KNModal";
import KNToaster from "@/kyna/ui/toaster/KNToaster";

import MetroBankLogo from "../../../public/assets/img/metrobank-logo.png";
import GCashLogo from "../../../public/assets/img/gcash-logo.png";
import GCashDonation from "../../../public/assets/img/Donation-GCash-QR-Code.png";
import PayPalLogo from "../../../public/assets/img/paypal-logo.png";

// const NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY = process.env.NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY

const getProvinces = async () => {
  return await KTGet("/api/maintenance/places/provinces", {
    limit: 100,
    orderBy: "prov_name,asc",
    select: "id,prov_code,prov_name",
  });
};

const getCities = async (prov_code) => {
  return await KTGet("/api/maintenance/places/cities", {
    limit: 100,
    orderBy: "city_name,asc",
    prov_code: prov_code,
    select: "id, city_code, city_name",
  });
};

const getBrgys = async (city_code) => {
  return await KTGet("/api/maintenance/places/brgys", {
    limit: 100,
    orderBy: "brgy_loc,asc",
    city_code: city_code,
    select: "id, brgy_loc",
  });
};
// Company/ Organization/ School address
const getCompanyProvinces = async () => {
  return await KTGet("/api/maintenance/places/provinces", {
    limit: 100,
    orderBy: "prov_name,asc",
    select: "id,prov_code,prov_name",
  });
};

const getCompanyCities = async (company_prov_code) => {
  return await KTGet("/api/maintenance/places/cities", {
    limit: 100,
    orderBy: "city_name,asc",
    prov_code: company_prov_code,
    select: "id, city_code, city_name",
  });
};

const getCompanyBrgys = async (company_city_code) => {
  return await KTGet("/api/maintenance/places/brgys", {
    limit: 100,
    orderBy: "brgy_loc,asc",
    city_code: company_city_code,
    select: "id, brgy_loc",
  });
};
const getDonations = async (params) => {
  return await KTGet("/api/donations", {
    limit: 1,
    orderBy: "created,desc",
  });
};

const Donations = (props) => {
  const NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY =
    process.env.NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY;
  const NEXT_PUBLIC_VERCEL_URL = process.env.NEXT_PUBLIC_VERCEL_URL;

  const [iconType, setIconType] = useState("error");
  const [modalMessage, setModalMessage] = useState("Server Failed");

  const [modalTitle, setModalTitle] = useState("Add job posting");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [formMessage, setFormMessage] = useState(null);
  const [formMessageType, setFormMessageType] = useState(null);
  const [SchemaErrors, setSchemaErrors] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [formResponse, setFormResponse] = useState({});
  const [initialValue, setInitialValue] = useState({
    // person table
    honorifics: null,
    first_name: "",
    middle_name: "",
    last_name: "",
    contact_no: "",
    email: "",

    // donation table
    occupation: "",
    company: "",
    amount_donate: "",
    payment_method: "",
    donated_to: "",
    othersInput: "",

    // address_book table
    address_line_1: "",
    province_id: 0,
    prov_code: "",
    city_code: "",
    city_id: 0,
    brgy_id: 0,
    province: "",
    city: "",
    brgy: "",

    address_line_2: "",
    company_province_id: 0,
    company_prov_code: "",
    company_city_code: "",
    company_city_id: 0,
    company_brgy_id: 0,

    file: "",
  });

  // USEQUERY FOR REFERENCE TABLE ON PAGE LOAD
  const {
    data: ProvincesData,
    status: ProvincesDataStatus,
    isLoading: ProvincesIsLoading,
  } = useQuery("ProvincesData", getProvinces);

  const {
    data: CompanyProvincesData,
    status: CompanyProvincesDataStatus,
    isLoading: CompanyProvincesIsLoading,
  } = useQuery("CompanyProvincesData", getCompanyProvinces);

  const [prov_code, setProvinceCode] = useState("PH-00");
  const [city_code, setCityCode] = useState("");
  const [CitiesData, setCitiesData] = useState({});
  const [BrgysData, setBrgysData] = useState({});

  const [company_prov_code, setCompanyProvinceCode] = useState("PH-00");
  const [company_city_code, setCompanyCityCode] = useState("");
  const [company_CitiesData, setCompanyCitiesData] = useState({});
  const [company_BrgysData, setCompanyBrgysData] = useState({});

  // ADDRESS BOOK
  const [addressBookID, setAddressBookID] = useState(0);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValue,
    validationSchema: ClientDonationsSchema,
    onSubmit: (values) => {
      console.log(values);
      submitHandler(values);
    },
  });

  useEffect(async () => {
    setCitiesData([]);
    setBrgysData([]);

    if (prov_code) {
      console.log("Province Code Changes " + prov_code);
      const citiesResponse = await getCities(prov_code);
      console.log("\ncitiesResponse", citiesResponse);

      if (citiesResponse.status == 200) {
        setCitiesData(citiesResponse);
      }
    }
  }, [prov_code]);

  useEffect(async () => {
    setBrgysData([]);
    if (city_code) {
      console.log("City Code Changes: " + city_code);
      const brgysResponse = await getBrgys(city_code);
      console.log("test brgy:" + brgysResponse);

      if (brgysResponse.status == 200) {
        setBrgysData(brgysResponse);
      }
    }
  }, [city_code]);

  useEffect(async () => {
    setCompanyCitiesData([]);
    setCompanyBrgysData([]);

    if (company_prov_code) {
      console.log("Province Code Changes1 " + company_prov_code);
      const companyCitiesResponse = await getCompanyCities(company_prov_code);
      console.log("\ncompanyCitiesResponse1", companyCitiesResponse);

      if (companyCitiesResponse.status == 200) {
        setCompanyCitiesData(companyCitiesResponse);
        console.log("success:", companyCitiesResponse.status);
      } else {
        console.log("error:", companyCitiesResponse.status);
      }
    }
  }, [company_prov_code]);

  useEffect(async () => {
    setCompanyBrgysData([]);
    if (company_city_code) {
      console.log("City Code Changes: " + company_city_code);
      const brgysResponse = await getCompanyBrgys(company_city_code);
      console.log("test brgy:" + brgysResponse);

      if (brgysResponse.status == 200) {
        setCompanyBrgysData(brgysResponse);
      }
    }
  }, [company_city_code]);

  const sanitizeHonorifics = (honorifics) => {
    if (honorifics[honorifics?.length - 1] == ".") {
      return honorifics;
    } else {
      return honorifics + ".";
    }
  };

  const submitHandler = async (values) => {
    setLoading(true);
    setIsSubmitLoading(true);

    const donationID = await getDonations();

    if (values.honorifics) {
      values.honorifics = sanitizeHonorifics(
        values.honorifics === "Others"
          ? values.others_honorifics
          : values.honorifics
      );
    }

    const donation_email =
      donationID?.data?.result == null
        ? format(new Date(), "yyyy") +
          "-" +
          uuid().substring(0, 6) +
          "_" +
          values.email
        : format(new Date(), "yyyy") +
          "-" +
          uuid().substring(0, 6) +
          "_" +
          values.email +
          donationID?.data?.result?.id +
          1;
    console.log("donation_email:", donation_email);
    // return
    let postData = {
      person: {
        honorifics: values.honorifics,
        first_name: values.first_name,
        last_name: values.last_name,
        middle_name: values.middle_name,
        contact_no: values.contact_no,
        email: donation_email,
        donation_id:
          donationID?.data?.result == null
            ? 1
            : donationID?.data?.result?.id + 1,
      },
      donation: {
        occupation: values.occupation,
        company: values.company,
        amount_donate: values.amount_donate,
        payment_method: values.payment_method,
        email: values.email,
        payment_method_others:
          values.payment_method == "others"
            ? values.payment_method_others
            : null,
        donated_to: values.donated_to.toString(),
        donated_to_others: values?.donated_to?.includes("Others")
          ? values.othersInput
          : null,
      },
      media: {
        file: values.file.cdnUrl,
      },
    };

    const saveDonationResponse = await KTPost("/api/donations", postData);

    setFormResponse(saveDonationResponse);
    console.log("Donation saveDonationResponse", saveDonationResponse);

    if (saveDonationResponse.status != 200) {
      console.log("error");
      console.log(saveDonationResponse.error);
      toast.dismiss();
      toast.error("There's an error occur, please check the form.", {
        ...KNThemeError,
      });
      setLoading(false);
      return;
    }

    if (
      saveDonationResponse.status == 200 &&
      saveDonationResponse.data.code == 422
    ) {
      console.log("error");
      console.log(saveDonationResponse);

      setSchemaErrors(saveDonationResponse.data.schemaErrors);
      toast.dismiss();
      toast.error("Donation Error! ", { ...KNThemeError });

      setLoading(false);
      return;
    }

    const donation_ID = await getDonations();

    let postDataPayment = {
      path: values.file.cdnUrl,
      file_name: values.file.name,
      orig_name: values.file.name,
      attach_id: donation_ID?.data?.result?.id,
      attachment_for: "Donation",
      user_id: 0,
      donation_id: donation_ID?.data?.result?.id,
      is_image: values.file.isImage,
      reference_id: values.file.uuid,
    };
    const result = await KTPost("/api/media/applicant", postDataPayment);

    console.log("postDataPayment", result);

    // Donator Address
    let addressBookPostData = {
      first_name: values.first_name,
      middle_name: values.middle_name,
      last_name: values.last_name,
      contact_no: values.contact_no,
      country: "Philippines",
      city: values.city,
      address_line_1: values.address_line_1,
      address_line_2: "",
      state: values.province,
      zip_postal: "",
      type: "Donator Address",
      status: "Active",
      google_map_address: "",
      long: 0,
      lat: 0,
      province_id: parseInt(values.province_id),
      cities_municipality_id: parseInt(values.city_id),
      barangay_id: parseInt(values.brgy_id),
      donator_id:
        donationID?.data?.result == null ? 1 : donationID?.data?.result?.id + 1,
    };

    if (addressBookID) {
      addressBookPostData.id = addressBookID;
    }
    const addressBook = await KTPost("/api/address_book", addressBookPostData);
    console.log("addressBook saveDonationResponse", addressBook);

    // Donation Company Address
    let companyAddressBookPostData = {
      first_name: values.first_name,
      middle_name: values.middle_name,
      last_name: values.last_name,
      contact_no: values.contact_no,
      country: "Philippines",
      city: values.company_city,
      address_line_1: "",
      address_line_2: values.address_line_2,
      state: values.company_province,
      zip_postal: "",
      type: "Donator Company Address",
      status: "Active",
      google_map_address: "",
      long: 0,
      lat: 0,
      province_id: parseInt(values.company_province_id),
      cities_municipality_id: parseInt(values.company_city_id),
      barangay_id: parseInt(values.company_brgy_id),
      donator_id:
        donationID?.data?.result == null ? 1 : donationID?.data?.result?.id + 1,
    };

    if (addressBookID) {
      companyAddressBookPostData.id = addressBookID;
    }
    const companyAddressBook = await KTPost(
      "/api/address_book",
      companyAddressBookPostData
    );
    console.log("addressBook saveDonationResponse", companyAddressBook);

    const date_today = format(new Date(), "MM/dd/yyyy");
    const time_today = new Date().toLocaleTimeString();

    const sendToEmails =
      process.env.NEXT_PUBLIC_KYNA_ENV === "development"
        ? ["kynatech.dev@gmail.com"]
        : ["accounting@pmha.org.ph"];

    // Donation email sent to PMHA
    const res = await fetch("/api/sendgrid", {
      body: JSON.stringify({
        email: sendToEmails,
        // email: "accounting@pmha.org.ph",
        subject: `New Donation from ${
          values?.honorifics
            ? `${values.honorifics} ${values.first_name}`
            : values.first_name
        } ${values.last_name} - (${date_today}-${time_today})`,
        // message: message.props.initialValue[0].children[0].text,
        html: `
        <!doctype html>
        <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
        
        <head>
          <title>Donation</title>
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <style type="text/css">
            #outlook a {
              padding: 0;
            }
            body {
              margin: 0;
              padding: 0;
              -webkit-text-size-adjust: 100%;
              -ms-text-size-adjust: 100%;
            }
            table,
            td {
              border-collapse: collapse;
              mso-table-lspace: 0pt;
              mso-table-rspace: 0pt;
            }
            img {
              border: 0;
              height: auto;
              line-height: 100%;
              outline: none;
              text-decoration: none;
              -ms-interpolation-mode: bicubic;
            }
            p {
              display: block;
              margin: 13px 0;
            }
            table.client-details tbody tr td {
              vertical-align: top;
              padding-left: 5px;
              padding-right: 5px;
            }
            .tbl-label {
              width: 35%;
            }
            .tbl-value {
              width: 65%;
            }
          </style>
        
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet">
        
          <style type="text/css">
            @import url(https://fonts.googleapis.com/css?family=Roboto:400,700);
          </style>
        
          <style type="text/css">
            @media only screen and (min-width:480px) {
              .mj-column-per-100 {
                width: 100% !important;
                max-width: 100%;
              }
              .mj-column-per-35 {
                width: 35% !important;
                max-width: 35%;
              }
              .mj-column-per-65 {
                width: 65% !important;
                max-width: 65%;
              }
            }
          </style>
          <style media="screen and (min-width:480px)">
            .moz-text-html .mj-column-per-100 {
              width: 100% !important;
              max-width: 100%;
            }
            .moz-text-html .mj-column-per-35 {
              width: 35% !important;
              max-width: 35%;
            }
            .moz-text-html .mj-column-per-65 {
              width: 65% !important;
              max-width: 65%;
            }
          </style>
          <style type="text/css">
            @media only screen and (max-width:480px) {
              table.mj-full-width-mobile {
                width: 100% !important;
              }
              td.mj-full-width-mobile {
                width: auto !important;
              }
        
              .site-logo,
              .site-name {
                display: block;
                width: 100%;
              }
              .site-logo {
                padding-bottom: 15px;
              }
              .site-name > div {
                padding-left: 0 !important;
              }
              .donation-details {
                padding: 10px 0 0 !important;
              }
        
            }
          </style>
        </head>
        
        <body style="word-spacing: normal; background-color: #f1f1f1;">
          <div style="background-color: #f1f1f1; padding-left: 20px; padding-right: 20px; padding-top: 20px;">
            <div style="margin: 30px auto; background-color: #ffffff; max-width: 600px;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%; background: #193e8c;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; text-align: center;">
                      <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width:100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                          <tbody>
                            <tr>
                              <td align="" style="padding: 20px 25px; word-break: break-word;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: collapse; border-spacing: 0px; margin: auto;">
                                  <tbody>
                                    <tr>
                                      <td class="site-logo" style="">
                                        <img alt="PMHA" height="auto" src="https://ucarecdn.com/b68fe996-fcc1-479c-ad51-778f8f283205/" style="border: 0; display: block; outline: none; text-decoration: none; height: auto; width: 100%; max-width: 80px; margin: auto;" />
                                      </td>
                                      <td class="site-name" style="">
                                        <div style="font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #ffffff; padding-left: 20px; max-width: 300px; margin: auto;">Philippine Mental Health Association Inc.</div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; padding: 0; text-align: center;">
                      <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                          <tbody>
                            <tr>
                              <td align="center" style="padding: 30px 25px 0; word-break: break-word;">
                                <div style="font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #193e8c;">Donation</div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%; max-width: 550px;">
                          <tbody>
                            <tr>
                              <td style="direction:ltr; font-size: 0px; padding: 30px 20px 20px;text-align:center;">
                                <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td align="center" style="font-size: 0px; padding: 10px 0; word-break: break-word;">
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 400; line-height: 1; text-align: left; color: #000000;">Hi, <strong>PMHA Team!</strong></div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">You have received a new donation.</div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">
                                            Here are the donor's details:
                                            <div class="donation-details" style="padding: 10px 15px 0;">
                                              <table class="client-details" style="width: 100%;">
                                                <tbody>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Name:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values?.honorifics
                                                        ? `${values.honorifics} ${values.first_name}`
                                                        : values.first_name
                                                    } ${values.middle_name} ${
          values.last_name
        }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Address:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values.address_line_1
                                                    } ${values.brgy} ${
          values.address_line_1
        } ${values.city}, ${values.province}.</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Contact No:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values.contact_no
                                                    }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Email:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values.email
                                                    }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Occupation:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values.occupation
                                                    }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Company / Organization / School:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values.company == ""
                                                        ? ""
                                                        : values.company
                                                    }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Company / Organization / School Address:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>${
                                                      values.address_line_2 ==
                                                        undefined ||
                                                      values.company_brgy ==
                                                        undefined ||
                                                      values.company_city ==
                                                        undefined ||
                                                      values.company_province ==
                                                        undefined
                                                        ? ""
                                                        : values.address_line_2 +
                                                          " " +
                                                          values.company_brgy +
                                                          " " +
                                                          values.company_city +
                                                          ", " +
                                                          values.company_province
                                                    }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Amount donated:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;"><strong>Php ${
                                                      values.amount_donate
                                                    }</strong></td>
                                                  </tr>
                                                  <tr>
                                                    <td class="tbl-label" style="font-size: 14px; padding-bottom: 0;">Donation will be applied to:</td>
                                                    <td class="tbl-value" style="font-size: 14px; padding-bottom: 0;">
                                                      <strong>
                                                      ${
                                                        includes(
                                                          values?.donated_to,
                                                          "All PMHA Programs and Services"
                                                        )
                                                          ? `<p style="margin: 0;">All PMHA Programs and Services</p>`
                                                          : values?.donated_to?.map(
                                                              (item) =>
                                                                item !== "," &&
                                                                `<p key={item} style="margin: 0;">${item}</p>`
                                                            )
                                                      }
                                                          ${
                                                            values.othersInput &&
                                                            `<p style="margin: 0;">${values.othersInput}</p>`
                                                          }
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: center; color: #000000; padding-top: 20px;">To check the donation application, please login to your account.</div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: center; color: #000000; padding-top: 20px; padding-bottom: 30px;">
                                            <a href="${NEXT_PUBLIC_VERCEL_URL}/app/dashboard" target="_blank" style="font-size: 14px; font-weight: 600; text-transform: uppercase; text-decoration: none; letter-spacing: 1px; background-color: #2eafcf; color: #fff; padding: 8px 15px; border-radius: 50px; display: block; max-width: 170px; width: 100%; margin: auto;">Click here to Login</a>
                                          </div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 12px; line-height: 20px; text-align: center; color: #000000; padding-bottom: 20px;">If the button above is not working, please <a href="${NEXT_PUBLIC_VERCEL_URL}/app/dashboard" target="_blank" style="text-decoration: underline; color: #2eafcf;">click here</a> to login.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="center" style="font-size: 0px; padding: 10px 0 60px; word-break: break-word;">
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 20px;">Thank you,</div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">PMHA Team</div>
                                        </td>
                                      </tr>
        
        
                                      <!-- EMAIL NOTIFICATION FOOTER -->
                                      <tr>
                                        <td align="center" style="font-size: 0px; padding-top: 15px; word-break: break-word; border-top: 1px solid #eee;">
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">
                                            <ul style="list-style: none; padding-left: 0; text-align: center; margin-top: 0; margin-bottom: 5px;">
                                              <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                <a href="https://www.facebook.com/PMHAofficial" target="_blank">
                                                  <img style="width: 14px;" src="https://ucarecdn.com/0869ab43-f54d-4f83-8781-8fed79d7938b/" alt="Facebook">
                                                </a>
                                              </li>
                                              <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                <a href="https://twitter.com/PMHAofficial" target="_blank">
                                                  <img style="width: 14px;" src="https://ucarecdn.com/f8e6e9fd-7f11-4515-b088-e5567a9915ba/" alt="Twitter">
                                                </a>
                                              </li>
                                              <li style="display: inline-block; padding: 0 8px; margin-left: 0; ">
                                                <a href="https://www.instagram.com/pmhaofficial/" target="_blank">
                                                  <img style="width: 14px;" src="https://ucarecdn.com/6b306f1a-796f-404f-86ba-400a0f766e83/" alt="Instagram">
                                                </a>
                                              </li>
                                              <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                <a href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w" target="_blank">
                                                  <img style="width: 14px;" src="https://ucarecdn.com/a822e322-e351-4d21-8bf7-14ac85a19f28/" alt="Youtube">
                                                </a>
                                              </li>
                                              <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                <a href="https://www.tiktok.com/@pmhaofficial" target="_blank">
                                                  <img style="width: 14px;" src="https://ucarecdn.com/2ed79507-7d8e-499c-afe6-85b2988aeea9/" alt="TikTok">
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 12px; font-weight: 400; line-height: 22px; text-align: center; color: #000000; letter-spacing: 2px;">PMHA © ${new Date().getFullYear()}</div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </body>
        
        </html>
          `,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });
    const { error } = await res.json();
    if (error) {
      console.log(error);
      return;
    }
    const rest = await fetch("/api/sendgrid", {
      body: JSON.stringify({
        email: values.email,
        subject: `Donation Confirmation - ${
          values?.honorifics
            ? `${values.honorifics} ${values.first_name}`
            : values.first_name
        } ${values.last_name} (${date_today}-${time_today})`,
        from: "accounting@pmha.org.ph",
        // message: message.props.initialValue[0].children[0].text,
        html: `
          <!doctype html>
          <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
          
          <head>
            <title>Donation</title>
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <style type="text/css">
              #outlook a {
                padding: 0;
              }
              body {
                margin: 0;
                padding: 0;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
              }
              table,
              td {
                border-collapse: collapse;
                mso-table-lspace: 0pt;
                mso-table-rspace: 0pt;
              }
              img {
                border: 0;
                height: auto;
                line-height: 100%;
                outline: none;
                text-decoration: none;
                -ms-interpolation-mode: bicubic;
              }
              p {
                display: block;
                margin: 13px 0;
              }
              table.client-details tbody tr td {
                vertical-align: top;
                padding-left: 5px;
                padding-right: 5px;
              }
              .tbl-label {
                width: 35%;
              }
              .tbl-value {
                width: 65%;
              }
            </style>
          
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet">
          
            <style type="text/css">
              @import url(https://fonts.googleapis.com/css?family=Roboto:400,700);
            </style>
          
            <style type="text/css">
              @media only screen and (min-width:480px) {
                .mj-column-per-100 {
                  width: 100% !important;
                  max-width: 100%;
                }
                .mj-column-per-35 {
                  width: 35% !important;
                  max-width: 35%;
                }
                .mj-column-per-65 {
                  width: 65% !important;
                  max-width: 65%;
                }
              }
            </style>
            <style media="screen and (min-width:480px)">
              .moz-text-html .mj-column-per-100 {
                width: 100% !important;
                max-width: 100%;
              }
              .moz-text-html .mj-column-per-35 {
                width: 35% !important;
                max-width: 35%;
              }
              .moz-text-html .mj-column-per-65 {
                width: 65% !important;
                max-width: 65%;
              }
            </style>
            <style type="text/css">
              @media only screen and (max-width:480px) {
                table.mj-full-width-mobile {
                  width: 100% !important;
                }
                td.mj-full-width-mobile {
                  width: auto !important;
                }
          
                .site-logo,
                .site-name {
                  display: block;
                  width: 100%;
                }
                .site-logo {
                  padding-bottom: 15px;
                }
                .site-name > div {
                  padding-left: 0 !important;
                }
                .donation-details {
                  padding: 10px 0 0 !important;
                }
          
              }
            </style>
          </head>
          
          <body style="word-spacing: normal; background-color: #f1f1f1;">
            <div style="background-color: #f1f1f1; padding-left: 20px; padding-right: 20px; padding-top: 20px;">
              <div style="margin: 30px auto; background-color: #ffffff; max-width: 600px;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%; background: #193e8c;">
                  <tbody>
                    <tr>
                      <td style="direction: ltr; text-align: center;">
                        <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                            <tbody>
                              <tr>
                                <td align="" style="padding: 20px 25px; word-break: break-word;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse: collapse; border-spacing: 0px; margin: auto;">
                                    <tbody>
                                      <tr>
                                        <td class="site-logo" style="">
                                          <img alt="PMHA" height="auto" src="https://ucarecdn.com/b68fe996-fcc1-479c-ad51-778f8f283205/" style="border: 0; display: block; outline: none; text-decoration: none; height: auto; width: 100%; max-width: 80px; margin: auto;" />
                                        </td>
                                        <td class="site-name" style="">
                                          <div style="font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #ffffff; padding-left: 20px; max-width: 300px; margin: auto;">Philippine Mental Health Association Inc.</div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                  <tbody>
                    <tr>
                      <td style="direction: ltr; padding: 0; text-align: center;">
                        <div class="mj-column-per-100 mj-outlook-group-fix" style="text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: middle;" width="100%">
                            <tbody>
                              <tr>
                                <td align="center" style="padding: 30px 25px 0; word-break: break-word;">
                                  <div style="font-family: 'Roboto', sans-serif; font-size: 20px; font-weight: 700; line-height: 28px; text-align: center; text-transform: uppercase; letter-spacing: 2px; color: #193e8c;">Donation</div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%; max-width: 550px;">
                            <tbody>
                              <tr>
                                <td style="direction:ltr; font-size: 0px; padding: 30px 20px 20px;text-align:center;">
                                  <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td align="center" style="font-size: 0px; padding: 10px 0; word-break: break-word;">
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 16px; font-weight: 400; line-height: 1; text-align: left; color: #000000;">Hi, <strong>${
                                              values?.honorifics
                                                ? `${values.honorifics} ${values.first_name}`
                                                : values.first_name
                                            }!</strong></div>
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">We have received your donation. We will get back to you once we verify your information.</div>
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 10px;">
                                              Here are your details:
                                              <div class="donation-details" style="padding: 10px 15px 0;">
                                                <table class="client-details" style="width: 100%;">
                                                  <tbody>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Name:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values?.honorifics
                                                          ? `${values.honorifics} ${values.first_name}`
                                                          : values.first_name
                                                      } ${values.middle_name} ${
          values.last_name
        }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Address:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values.address_line_1
                                                      } ${values.brgy} ${
          values.address_line_1
        } ${values.city}, ${values.province}.</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Contact No:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values.contact_no
                                                      }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Email:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values.email
                                                      }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Occupation:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values.occupation
                                                      }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Company / Organization / School:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values.company == ""
                                                          ? ""
                                                          : values.company
                                                      }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Company / Organization / School Address:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>${
                                                        values.address_line_2 ==
                                                          undefined ||
                                                        values.company_brgy ==
                                                          undefined ||
                                                        values.company_city ==
                                                          undefined ||
                                                        values.company_province ==
                                                          undefined
                                                          ? ""
                                                          : values.address_line_2 +
                                                            " " +
                                                            values.company_brgy +
                                                            " " +
                                                            values.company_city +
                                                            ", " +
                                                            values.company_province
                                                      }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Amount donated:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;"><strong>Php ${
                                                        values.amount_donate
                                                      }</strong></td>
                                                    </tr>
                                                    <tr>
                                                      <td class="tbl-label" style="font-size: 12px; padding-bottom: 8px;">Donation will be applied to:</td>
                                                      <td class="tbl-value" style="font-size: 12px; padding-bottom: 8px;">
                                                        <strong>
                                                        ${
                                                          includes(
                                                            values?.donated_to,
                                                            "All PMHA Programs and Services"
                                                          )
                                                            ? `<p style="margin: 0;">All PMHA Programs and Services</p>`
                                                            : values?.donated_to?.map(
                                                                (item) =>
                                                                  item !==
                                                                    "," &&
                                                                  `<p key={item} style="margin: 0;">${item}</p>`
                                                              )
                                                        }
                                                          ${
                                                            values.othersInput &&
                                                            `<p style="margin: 0;">${values.othersInput}</p>`
                                                          }
                                                        </strong>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td align="center" style="font-size: 0px; padding: 10px 0 60px; word-break: break-word;">
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 14px; line-height: 22px; text-align: left; color: #000000; padding-top: 20px;">Thank you,</div>
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">PMHA Team</div>
                                          </td>
                                        </tr>
          
          
                                        <!-- EMAIL NOTIFICATION FOOTER -->
                                        <tr>
                                          <td align="center" style="font-size: 0px; padding-top: 15px; word-break: break-word; border-top: 1px solid #eee;">
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 600; line-height: 22px; text-align: left; color: #000000;">
                                              <ul style="list-style: none; padding-left: 0; text-align: center; margin-top: 0; margin-bottom: 5px;">
                                                <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                  <a href="https://www.facebook.com/PMHAofficial" target="_blank">
                                                    <img style="width: 14px;" src="https://ucarecdn.com/0869ab43-f54d-4f83-8781-8fed79d7938b/" alt="Facebook">
                                                  </a>
                                                </li>
                                                <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                  <a href="https://twitter.com/PMHAofficial" target="_blank">
                                                    <img style="width: 14px;" src="https://ucarecdn.com/f8e6e9fd-7f11-4515-b088-e5567a9915ba/" alt="Twitter">
                                                  </a>
                                                </li>
                                                <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                  <a href="https://www.instagram.com/pmhaofficial/" target="_blank">
                                                    <img style="width: 14px;" src="https://ucarecdn.com/6b306f1a-796f-404f-86ba-400a0f766e83/" alt="Instagram">
                                                  </a>
                                                </li>
                                                <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                  <a href="https://www.youtube.com/channel/UCvZjwCE8FucFXNrcGjgPz_w" target="_blank">
                                                    <img style="width: 14px;" src="https://ucarecdn.com/a822e322-e351-4d21-8bf7-14ac85a19f28/" alt="Youtube">
                                                  </a>
                                                </li>
                                                <li style="display: inline-block; padding: 0 8px; margin-left: 0;">
                                                  <a href="https://www.tiktok.com/@pmhaofficial" target="_blank">
                                                    <img style="width: 14px;" src="https://ucarecdn.com/2ed79507-7d8e-499c-afe6-85b2988aeea9/" alt="TikTok">
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                            <div style="font-family: 'Roboto', sans-serif; font-size: 12px; font-weight: 400; line-height: 22px; text-align: center; color: #000000; letter-spacing: 2px;">PMHA © ${new Date().getFullYear()}</div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </body>
          
          </html>
          `,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });
    const { errors } = await rest.json();
    if (errors) {
      console.log(errors);
      return;
    }

    setIconType("info");
    setModalTitle("Success");
    setModalMessage(
      "Thank you for your donation. We appreciate your generosity."
    );

    setLoading(false);
    setIsOpenModal(true);
  };
  const today = new Date();

  const handleCheckBoxInput = (value, checked) => {
    const allPrograms = [
      "Education and Advocacy",
      "Clinical and Intervention Services",
      "Monitoring, Evaluation, and Research",
    ];

    if (checked) {
      if (value === "All PMHA Programs and Services") {
        formik.setFieldValue("donated_to", [
          value,
          ...allPrograms,
          ...formik.values.donated_to,
        ]);
      } else {
        const combined = [...formik.values.donated_to, value];
        const selected = [...new Set(combined)];

        const hasAll = allPrograms.every((program) =>
          selected.includes(program)
        );

        if (hasAll) {
          formik.setFieldValue("donated_to", [
            "All PMHA Programs and Services",
            ...selected,
          ]);
        } else {
          formik.setFieldValue("donated_to", selected);
        }
      }
    } else {
      if (value === "All PMHA Programs and Services") {
        const values = formik.values.donated_to.filter(
          (i) => ![value, ...allPrograms].includes(i)
        );
        formik.setFieldValue("donated_to", values);
        return;
      }

      if (
        formik.values.donated_to.includes("All PMHA Programs and Services") &&
        value !== "Others"
      ) {
        const values = formik.values.donated_to.filter(
          (i) => i !== "All PMHA Programs and Services" && i !== value
        );
        formik.setFieldValue("donated_to", values);
        return;
      }

      const values = formik.values.donated_to.filter((i) => i !== value);
      formik.setFieldValue("donated_to", values);
    }
  };

  return (
    <>
      {/* MAIN NAV */}
      <>
        <HeaderNav />
      </>

      {/* Contact Page Section */}
      <>
        <section className="lg:py-32 py-28 lg:px-12 md:px-8 px-5">
          {/* <section className="bg-gray-100 min-h-screen p-10"> */}

          <div className="container max-w-4xl mx-auto">
            <div className="mt-5">
              <h1 className="font-medium text-black">Donation</h1>
              <p className="sm:text-lg text-base text-justify">
                For every peso donated, PMHA gives 80% to fund our programs and
                services for the clients and 20% to efficiently support our
                operation cost. With you as our partner, imagine what we can do
                together and how many more lives we can transform. With PMHA,
                donors and funders are not helping just another organization.
                They are a part of a worthy purpose of formulating new quality
                programs to respond to the changing times and ensure that mental
                health services are made accessible, affordable and available to
                the public.
              </p>
            </div>

            <div className="">
              <form onSubmit={formik.handleSubmit}>
                <div className="mb-5">
                  <header className="flex mt-5 mb-3">
                    <h2 className="text-blue-500 text-xl uppercase tracking-wider mb-0">
                      Personal Information
                    </h2>
                  </header>
                  <div className="grid md:grid-cols-3 grid-cols-1 gap-3">
                    <SelectInputForm
                      id="honorifics"
                      placeholder="Salutation"
                      formik={formik}
                      options={HONORIFICS}
                      label="Salutation"
                    />
                    {formik.values.honorifics === "Others" && (
                      <InputFormV2
                        id="others_honorifics"
                        name="others_honorifics"
                        placeholder="Please specify"
                        formik={formik}
                        label="Please specify"
                      />
                    )}
                  </div>
                  <div className="grid">
                    <label className="control-label block mb-1">
                      Name <span className="text-red-600">*</span>
                    </label>
                    <div className="grid md:grid-cols-3 grid-cols-1 gap-3 mb-4">
                      <div className="form-group !mb-0">
                        <InputForm
                          type="text"
                          id="first_name"
                          name="first_name"
                          placeholder="First Name"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full md:!mb-3 !mb-1"
                        />
                      </div>
                      <div className="form-group !mb-0">
                        <InputForm
                          type="text"
                          id="middle_name"
                          name="middle_name"
                          placeholder="Middle Name"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full md:!mb-3 !mb-1"
                        />
                      </div>
                      <div className="form-group !mb-0">
                        <InputForm
                          type="text"
                          id="last_name"
                          name="last_name"
                          placeholder="Last Name"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full md:!mb-3 !mb-1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid">
                    <label className="control-label block mb-1">
                      Address <span className="text-red-600">*</span>
                    </label>
                    <div className="grid grid-cols-1 md:mb-0 mb-3">
                      <div className="form-group !mb-0">
                        <InputForm
                          type="text"
                          id="address_line_1"
                          name="address_line_1"
                          placeholder="Address Line 1"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full md:!mb-3 !mb-1"
                        />
                      </div>
                    </div>
                    <div className="grid md:grid-cols-3 grid-cols-1 gap-3">
                      <div className="">
                        <select
                          name="province_id"
                          id="province_id"
                          value={
                            !isEmpty(ProvincesData?.data) &&
                            formik.values?.province_id &&
                            formik.values.province_id
                          }
                          className="form-control"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const optionSelected =
                              e.target[e.target.selectedIndex];

                            console.log("province_name", value);
                            formik.setFieldValue(
                              "province",
                              optionSelected.getAttribute("prov-name")
                            );
                            formik.setFieldValue(
                              "province_id",
                              optionSelected.getAttribute("prov-id")
                            );
                            // setProvinceID(value)
                            setProvinceCode(
                              optionSelected.getAttribute("prov-code")
                            );
                            // RUN GET CITIES HERE
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select Province</option>

                          {ProvincesData?.data &&
                            !isEmpty(ProvincesData.data) &&
                            ProvincesData.data.map((province) => (
                              <option
                                key={"province-" + province.id}
                                prov-id={province.id}
                                prov-code={province.prov_code}
                                prov-name={province.prov_name}
                                value={province.id}
                              >
                                {province.prov_name}
                              </option>
                            ))}
                        </select>
                        <div className="help-block text-red-400 mt-2">
                          {formik.touched.province &&
                            formik.errors.province && (
                              <div>{formik.errors.province}</div>
                            )}
                        </div>
                      </div>
                      <div className="form-group">
                        <select
                          name="city_id"
                          id="city_id"
                          value={
                            !isEmpty(CitiesData?.data) &&
                            formik.values?.id &&
                            formik.values.id
                          }
                          className="form-control"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const optionSelected =
                              e.target[e.target.selectedIndex];
                            console.log("city", value);
                            formik.setFieldValue(
                              "city",
                              optionSelected.getAttribute("city-name")
                            );
                            formik.setFieldValue(
                              "city_id",
                              optionSelected.getAttribute("city-id")
                            );
                            // setCityID(value)
                            setCityCode(
                              optionSelected.getAttribute("city-code")
                            );

                            // RUN GET CITIES HERE
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select City</option>
                          {CitiesData?.data &&
                            !isEmpty(CitiesData.data) &&
                            CitiesData.data.map((city) => (
                              <option
                                key={"city-" + city.id}
                                city-id={city.id}
                                city-code={city.city_code}
                                city-name={city.city_name}
                                value={city.id}
                              >
                                {city.city_name}
                              </option>
                            ))}
                        </select>
                        <div className="help-block text-red-400 mt-2">
                          {formik.touched.city && formik.errors.city && (
                            <div>{formik.errors.city}</div>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <select
                          name="brgy_id"
                          id="brgy_id"
                          value={
                            !isEmpty(BrgysData?.data) &&
                            formik.values?.brgy_id &&
                            formik.values.brgy_id
                          }
                          className="form-control"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const optionSelected =
                              e.target[e.target.selectedIndex];
                            console.log("brgy id", value);
                            formik.setFieldValue(
                              "brgy",
                              optionSelected.getAttribute("brgy-name")
                            );
                            formik.setFieldValue(
                              "brgy_id",
                              optionSelected.getAttribute("brgy-id")
                            );
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select Brgy</option>

                          {BrgysData?.data &&
                            !isEmpty(BrgysData.data) &&
                            BrgysData.data.map((brgy) => (
                              <option
                                key={"brgy-" + brgy.id}
                                brgy-id={brgy.id}
                                brgy-name={brgy.brgy_loc}
                                value={brgy.id}
                              >
                                {brgy.brgy_loc}
                              </option>
                            ))}
                        </select>

                        <div className="help-block text-red-400 mt-2">
                          {formik.touched.brgy && formik.errors.brgy && (
                            <div>{formik.errors.brgy}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="grid grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="control-label block mb-1">
                          Contact No. <span className="text-red-600">*</span>
                        </label>
                        <InputForm
                          type="text"
                          id="contact_no"
                          name="contact_no"
                          placeholder="Contact Number"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full"
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label block mb-1">
                          Email Address <span className="text-red-600">*</span>
                        </label>
                        <InputForm
                          type="text"
                          id="email"
                          name="email"
                          placeholder="Email Address"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="grid grid-cols-2 gap-3">
                      <div className="form-group">
                        <label className="control-label block mb-1">
                          Occupation <span className="text-red-600">*</span>
                        </label>
                        <InputForm
                          type="text"
                          id="occupation"
                          name="occupation"
                          placeholder="Occupation"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full"
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label block mb-1">
                          Company/Organization/School
                        </label>
                        <InputForm
                          type="text"
                          id="company"
                          name="company"
                          placeholder="Company/Organization/School (if any)"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="grid grid-cols-1">
                      <div className="form-group !mb-0">
                        <label className="control-label block mb-1">
                          Company/Organization/School Address (if any)
                        </label>
                        <InputForm
                          type="text"
                          id="address_line_2"
                          name="address_line_2"
                          placeholder="House, Bldg St. No."
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full"
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-3">
                      <div className="form-group">
                        <select
                          name="company_province_id"
                          id="company_province_id"
                          value={
                            !isEmpty(CompanyProvincesData?.data) &&
                            formik.values?.company_province_id &&
                            formik.values.company_province_id
                          }
                          className="form-control"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const optionSelected =
                              e.target[e.target.selectedIndex];

                            console.log("company_province_name: ", value);
                            formik.setFieldValue(
                              "company_province",
                              optionSelected.getAttribute("prov-name")
                            );
                            formik.setFieldValue(
                              "company_province_id",
                              optionSelected.getAttribute("prov-id")
                            );
                            // setProvinceID(value)
                            setCompanyProvinceCode(
                              optionSelected.getAttribute("prov-code")
                            );
                            console.log(
                              "TESTING:",
                              optionSelected.getAttribute("prov-code")
                            );
                            // RUN GET CITIES HERE
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select province</option>
                          {CompanyProvincesData?.data &&
                            !isEmpty(CompanyProvincesData.data) &&
                            CompanyProvincesData.data.map(
                              (company_province) => (
                                <option
                                  key={
                                    "company_province-" + company_province.id
                                  }
                                  prov-id={company_province.id}
                                  prov-code={company_province.prov_code}
                                  prov-name={company_province.prov_name}
                                  value={company_province.id}
                                >
                                  {company_province.prov_name}
                                </option>
                              )
                            )}
                        </select>
                        {/* <pre>{JSON.stringify( CompanyProvincesData?.data,null,1)}</pre> */}

                        <div className="help-block text-red-600 text-sm mt-2">
                          {formik.touched.company_province_id &&
                            formik.errors.company_province_id && (
                              <div>{formik.errors.company_province_id}</div>
                            )}
                        </div>
                      </div>
                      <div className="form-group">
                        <select
                          name="company_city_id"
                          id="company_city_id"
                          value={
                            !isEmpty(company_CitiesData?.data) &&
                            formik.values?.company_city_id &&
                            formik.values.company_city_id
                          }
                          className="form-control"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const optionSelected =
                              e.target[e.target.selectedIndex];
                            console.log("city", value);
                            formik.setFieldValue(
                              "company_city",
                              optionSelected.getAttribute("company-city-name")
                            );
                            formik.setFieldValue(
                              "company_city_id",
                              optionSelected.getAttribute("city-id")
                            );
                            // setCityID(value)
                            setCompanyCityCode(
                              optionSelected.getAttribute("city-code")
                            );

                            // RUN GET CITIES HERE
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select City</option>
                          {company_CitiesData?.data &&
                            !isEmpty(company_CitiesData.data) &&
                            company_CitiesData.data.map((company_city) => (
                              <option
                                key={"company_city-" + company_city.id}
                                city-id={company_city.id}
                                city-code={company_city.city_code}
                                company-city-name={company_city.city_name}
                                value={company_city.id}
                              >
                                {company_city.city_name}
                              </option>
                            ))}
                        </select>
                        <div className="help-block text-red-600 text-sm mt-2">
                          {formik.touched.company_city_id &&
                            formik.errors.company_city_id && (
                              <div>{formik.errors.company_city_id}</div>
                            )}
                        </div>
                      </div>
                      <div className="form-group">
                        <select
                          name="company_brgy_id"
                          id="company_brgy_id"
                          value={
                            !isEmpty(company_BrgysData?.data) &&
                            formik.values?.company_brgy_id &&
                            formik.values.company_brgy_id
                          }
                          className="form-control"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const optionSelected =
                              e.target[e.target.selectedIndex];
                            console.log("brgy id", value);
                            formik.setFieldValue(
                              "company_brgy",
                              optionSelected.getAttribute("brgy-name")
                            );
                            formik.setFieldValue(
                              "company_brgy_id",
                              optionSelected.getAttribute("brgy-id")
                            );
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select Brgy</option>

                          {company_BrgysData?.data &&
                            !isEmpty(company_BrgysData.data) &&
                            company_BrgysData.data.map((brgy) => (
                              <option
                                key={"brgy-" + brgy.id}
                                brgy-id={brgy.id}
                                brgy-name={brgy.brgy_loc}
                                value={brgy.id}
                              >
                                {brgy.brgy_loc}
                              </option>
                            ))}
                        </select>

                        <div className="help-block text-red-600 text-sm mt-2">
                          {formik.touched.company_brgy_id &&
                            formik.errors.company_brgy_id && (
                              <div>{formik.errors.company_brgy_id}</div>
                            )}
                        </div>
                        {/* <pre>{JSON.stringify(company_CitiesData?.data, null ,1)}</pre> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-5">
                  <header className="flex mt-5 mb-3">
                    <h2 className="text-blue-500 text-xl uppercase tracking-wider mb-0">
                      Donation Information
                    </h2>
                  </header>
                  <div className="grid">
                    <div className="grid grid-cols-2">
                      <div className="form-group">
                        <label className="control-label block mb-1">
                          Amount <span className="text-red-600">*</span>
                        </label>
                        <InputForm
                          type="number"
                          id="amount_donate"
                          name="amount_donate"
                          placeholder="Amount in PHP"
                          withFormik={true}
                          formik={formik}
                          parentClassName="w-full"
                        />
                      </div>
                    </div>
                    <div className="grid">
                      <div className="form-group">
                        <label className="control-label block mb-3">
                          I would like my donation applied towards:{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <div className="grid grid-cols-3 gap-3 mb-2">
                          <label className="checkbox-form-group text-sm">
                            <input
                              className="checkbox-form-control"
                              value="All PMHA Programs and Services"
                              name="all"
                              id="all"
                              type="checkbox"
                              checked={formik.values.donated_to.includes(
                                "All PMHA Programs and Services"
                              )}
                              onChange={(e) => {
                                const { value, checked } = e.target;
                                handleCheckBoxInput(value, checked);
                              }}
                            />
                            All PMHA Programs and Services
                          </label>
                          <label className="checkbox-form-group text-sm">
                            <input
                              className="checkbox-form-control"
                              value="Education and Advocacy"
                              name="ear"
                              id="ear"
                              type="checkbox"
                              checked={formik.values.donated_to.includes(
                                "Education and Advocacy"
                              )}
                              onChange={(e) => {
                                const { value, checked } = e.target;
                                handleCheckBoxInput(value, checked);
                              }}
                            />
                            Education and Advocacy
                          </label>
                          <label className="checkbox-form-group text-sm">
                            <input
                              className="checkbox-form-control"
                              value="Clinical and Intervention Services"
                              name="cis"
                              id="cis"
                              type="checkbox"
                              checked={formik.values.donated_to.includes(
                                "Clinical and Intervention Services"
                              )}
                              onChange={(e) => {
                                const { value, checked } = e.target;
                                handleCheckBoxInput(value, checked);
                              }}
                            />
                            Clinical and Intervention Services
                          </label>
                          <label className="checkbox-form-group text-sm">
                            <input
                              className="checkbox-form-control"
                              value="Monitoring, Evaluation, and Research"
                              name="mer"
                              id="mer"
                              type="checkbox"
                              checked={formik.values.donated_to.includes(
                                "Monitoring, Evaluation, and Research"
                              )}
                              onChange={(e) => {
                                const { value, checked } = e.target;
                                handleCheckBoxInput(value, checked);
                              }}
                            />
                            Monitoring, Evaluation, and Research
                          </label>
                        </div>
                        <div className="flex items-center">
                          <label className="checkbox-form-group text-sm">
                            <input
                              className="checkbox-form-control"
                              value="Others"
                              name="others"
                              id="others"
                              type="checkbox"
                              checked={formik.values.donated_to.includes(
                                "Others"
                              )}
                              onChange={(e) => {
                                const { value, checked } = e.target;
                                handleCheckBoxInput(value, checked);
                              }}
                            />
                            Others
                          </label>
                          <div className="form-group !mb-0 ml-4 w-full">
                            <InputForm
                              type="text"
                              id="othersInput"
                              name="othersInput"
                              placeholder="Please specify"
                              withFormik={true}
                              formik={formik}
                              parentClassName="w-full !mb-0"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="help-block text-red-400 mt-2">
                        {formik.touched.donated_to &&
                          formik.errors.donated_to && (
                            <div>{formik.errors.donated_to}</div>
                          )}
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3 mt-3">
                      <div className="form-group">
                        <label className="control-label block mb-1">
                          Payment Method <span className="text-red-600">*</span>
                        </label>
                        <select
                          name="payment_method"
                          id="payment_method"
                          className="form-control"
                          onChange={(e) => {
                            // handleChange(e)
                            const { name, value } = e.target;
                            console.log("payment_method", value);
                            formik.setFieldValue("payment_method", value);
                          }}
                          value={formik.values?.payment_method}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Payment Method</option>
                          <option value="Bank_Transfer">Bank Transfer</option>
                          <option value="Gcash">Gcash</option>
                          <option value="PayPal">PayPal</option>
                          {/* <option value="others">Other</option> */}
                        </select>
                        <div className="help-block text-red-400 mt-2">
                          {formik.touched.payment_method &&
                            formik.errors.payment_method && (
                              <div>{formik.errors.payment_method}</div>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="">
                      {formik.values.payment_method == "Bank_Transfer" ? (
                        <>
                          <div className="animate-[wiggle_1s_ease-in-out_infinite] rounded-md p-8 mb-5 bg-[#EEF1F6]">
                            <p className="font-bold mb-3">
                              Bank transfer information:
                            </p>
                            <div className="max-w-[180px] pb-3">
                              <Image src={MetroBankLogo} alt="Metrobank Logo" />
                            </div>
                            <div className="">
                              <div className="flex items-center">
                                <p className="basis-[150px]">Bank Name:</p>
                                <p className="font-bold">Metrobank</p>
                              </div>
                              <div className="flex items-center">
                                <p className="basis-[150px]">Account Name:</p>
                                <p className="font-bold">
                                  {" "}
                                  Philippine Mental Health Association, Inc
                                </p>
                              </div>
                              <div className="flex items-center">
                                <p className="basis-[150px]">Account No.:</p>
                                <p className="font-bold"> 232-3232-50049-3</p>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {formik.values.payment_method == "Gcash" ? (
                        <>
                          <div className="animate-[wiggle_1s_ease-in-out_infinite] rounded-md p-8 mb-5 bg-[#EEF1F6]">
                            <div className="flex flex-wrap">
                              <div>
                                <p className="text-lg text-black mb-3">
                                  Scan the QR Code:{" "}
                                </p>
                                <div className="max-w-[180px] pb-3">
                                  <Image src={GCashLogo} alt="GCash Logo" />
                                </div>
                              </div>
                              <div className="max-w-[200px] ml-8">
                                <Image
                                  src={GCashDonation}
                                  alt="GCash QR Code"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {formik.values.payment_method == "PayPal" ? (
                        <>
                          <div className="animate-[wiggle_1s_ease-in-out_infinite] rounded-md p-8 mb-5 bg-[#EEF1F6]">
                            <div className="max-w-[160px] pb-3">
                              <Image src={PayPalLogo} alt="PayPal Logo" />
                            </div>
                            <div className="">
                              <div className="flex items-center">
                                <p className="basis-[160px]">
                                  Account information:
                                </p>
                                <p className="font-bold">oned@pmha.org.ph</p>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="flex items-center">
                        <label className="control-label block mb-1 mr-4">
                          Proof of Payment{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <Widget
                          publicKey={NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY}
                          imagesOnly={true}
                          id="file"
                          name="file"
                          tabs="file"
                          onFileSelect={(file) => {
                            console.log("File changed: ", file);

                            if (file) {
                              file.progress((info) =>
                                console.log("File progress: ", info.progress)
                              );
                              file.done((info) => {
                                console.log("File uploaded: ", info);
                                // setCVPic(info.cdnUrl)
                                formik.setFieldValue("file", info);
                                // saveMediaFile(info)
                              });
                            }
                          }}
                          onChange={(info) =>
                            console.log("Upload completed:", info)
                          }
                        />
                      </div>
                      <div className="help-block text-red-400 mt-2">
                        {formik.touched.file && formik.errors.file && (
                          <div>{formik.errors.file}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-5">
                  <div className="form-group">
                    {/* <pre>{JSON.stringify(formik.values, null, 1)}</pre> */}
                  </div>
                  <div className="form-group">
                    {formMessage != "" ? (
                      <div className={`mt-1 mb-2 ${formMessageType}`}>
                        {formMessage}
                      </div>
                    ) : null}

                    {/* <pre>
                          {JSON.stringify(formik.errors, null, 1)}
                          </pre> */}
                  </div>
                </div>

                <div className="form-group text-right">
                  <button
                    type="submit"
                    disabled={isLoading ? true : false}
                    className="btn btn-lg btn-primary rounded-full py-3 px-8"
                  >
                    <Spinner isLoading={isLoading} />
                    {!isLoading && "Submit"}
                  </button>
                  {/* <button
                    type='button'
                    onClick={() => router.push("/")}
                    className="btn btn-lg bg-white border border-gray-100">
                    Cancel
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </section>
        <KNModal
          title={modalTitle}
          iconType={iconType}
          isOpen={isOpenModal}
          noFooter={true}
          bodyClass={"max-w-4xl mt-10"}
          closeModal={() => {
            setIsOpenModal(false);
          }}
          body={
            <DonationModal
              modalMessage={modalMessage}
              setIsOpenModal={setIsOpenModal}
              iconType={iconType}
            />
          }
        />
        <KNToaster />
      </>

      {/* Footer */}
      <>
        <Footer />
      </>
    </>
  );
};

const DonationModal = ({ modalMessage, setIsOpenModal, iconType }) => {
  return (
    <div>
      <p>{modalMessage}</p>
      <div className="flex w-full flex-row-reverse gap-2 mt-2 text-white">
        {iconType === "info" ? (
          <button
            className="bg-gray-400 hover:bg-gray-600 w-20 py-2 rounded-md"
            onClick={() => {
              setIsOpenModal(false);
              window.location.reload();
            }}
          >
            Close
          </button>
        ) : (
          <button
            className="bg-red-400 hover:bg-red-600 w-20 py-2 rounded-md"
            onClick={() => {
              setIsOpenModal(false);
              window.location.reload("/");
            }}
          >
            OK
          </button>
        )}
      </div>
    </div>
  );
};

export default Donations;
